// src/pages/SinhBoSoQr/modals/ConfirmSinhBoSoDialog.tsx
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { KyPhatHanh, LOAI_VE_MAU_LABELS } from '../types';
import moment from 'moment';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('sinh_bo_so_qr');

interface ConfirmSinhBoSoDialogProps {
  isOpen: boolean;
  kyPhatHanh: KyPhatHanh | null;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmSinhBoSoDialog: React.FC<ConfirmSinhBoSoDialogProps> = ({
  isOpen,
  kyPhatHanh,
  loading,
  onConfirm,
  onClose,
}) => {
  const location = useLocation();

  if (!kyPhatHanh) return null;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="md">
      <ModalHeader toggle={onClose}>
        <i className="ri-qr-code-line text-primary me-2"></i>
        {st('xac_nhan_sinh_bo_so_ma_title')}
      </ModalHeader>
      <ModalBody>
        {/* Read-only info — không có form input */}
        <div className="alert alert-info mb-3">
          <i className="ri-information-line me-2"></i>
          {st('vui_long_kiem_tra_thong_tin_text')}
        </div>

        <div className="table-responsive">
          <table className="table table-borderless table-sm mb-0">
            <tbody>
                            <tr>
                <td className="fw-semibold text-muted" style={{ width: '45%' }}>
                  {st('ky_phat_hanh_text')}
                </td>
                <td className="fw-semibold">{kyPhatHanh.periodName}</td>
              </tr>
              <tr>
                <td className="fw-semibold text-muted">{st('loai_ve_mau_text')}</td>
                <td>{LOAI_VE_MAU_LABELS[kyPhatHanh.ticketType] || kyPhatHanh.ticketType}</td>
              </tr>
              <tr>
                <td className="fw-semibold text-muted">{st('so_luong_ve_text')}</td>
                <td className="text-primary fw-bold">
                  {kyPhatHanh.ticketQuantity.toLocaleString('vi-VN')}
                </td>
              </tr>
              <tr>
                <td className="fw-semibold text-muted">{st('dai_so_text')}</td>
                <td>
                  <span className="badge bg-secondary me-1">{kyPhatHanh.numberRangeStart}</span>
                  <i className="ri-arrow-right-line mx-1"></i>
                  <span className="badge bg-secondary">{kyPhatHanh.numberRangeEnd}</span>
                </td>
              </tr>
              {kyPhatHanh.ticketSymbols && kyPhatHanh.ticketSymbols.length > 0 && (
                <tr>
                  <td className="fw-semibold text-muted">{st('ky_hieu_ve_phu_text')}</td>
                  <td>
                    {kyPhatHanh.ticketSymbols.map((ky, idx) => (
                      <span key={idx} className="badge bg-info me-1">
                        {ky}
                      </span>
                    ))}
                  </td>
                </tr>
              )}
              <tr>
                <td className="fw-semibold text-muted">{st('ngay_su_dung_text')}</td>
                <td>{moment(kyPhatHanh.useDate).format('DD/MM/YYYY')}</td>
              </tr>
            </tbody>
          </table>
        </div>

                <div className="alert alert-warning mt-3 mb-0">
          <i className="ri-time-line me-2"></i>
          <strong>{st('luu_y_text')}</strong> {st('thao_tac_nay_se_sinh_text')}{' '}
          <strong>{kyPhatHanh.ticketQuantity.toLocaleString('vi-VN')}</strong> {st('ve_va_ma_qr_dinh_danh_text')}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose} disabled={loading}>
          {st('huy_button')}
        </Button>
        {PageActionPermission.canDisplay(location.pathname, 'button-generate-confirm') && (
          <Button
            color="primary"
            data-action-code="button-generate-confirm"
            data-action-name="Xác nhận sinh bộ số & QR"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-1" />
                {st('dang_khoi_dong_text')}
              </>
            ) : (
              <>
                <i className="ri-qr-code-line me-1"></i>
                {st('sinh_bo_so_qr_text')}
              </>
            )}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmSinhBoSoDialog;